import { createEmotionCache as createEmotionCacheNext } from '@inflearn/ds-react-next';

export const styleCacheNext = createEmotionCacheNext({
  key: 'mantine-next',
});
